import { render } from "./AssociateFinancialLifeView.vue?vue&type=template&id=4ef8e3f1&scoped=true"
import script from "./AssociateFinancialLifeView.vue?vue&type=script&lang=js"
export * from "./AssociateFinancialLifeView.vue?vue&type=script&lang=js"

import "./AssociateFinancialLifeView.vue?vue&type=style&index=0&id=4ef8e3f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef8e3f1"]])

export default __exports__